
export default {

    translations: {},

    setTranslations: function (t:any) {
        for(let prop in t) {
            this.translations[prop] = t[prop]
        }
    },

    t: function(value: string, options: any|null = null) {
        if ( typeof this.translations[value] == 'undefined' ) {
            return value
        }
        let string = this.translations[value];
        if ( typeof options == 'object' ) {
            for(const prop in options) {
                const re = new RegExp('{'+prop+'}')
                string = string.replace(re,options[prop])
            }
        }
        return string
    }
}


// WEBPACK FOOTER //
// ./react/src/utils/translations.ts